import Search from 'gatsby-theme-husky/src/components/Header/HeaderSearch/Search';

import './SearchOverride.scss';

export default Search;
